<template>
  <vx-card class="vx-card_full-height">
    <div class="mb-4">
      <vs-button
        :to="{ name: 'uc_notifies'}"
        type="border"
        icon="keyboard_backspace"
      >
        Назад
      </vs-button>
    </div>
    <h3 class="mb-8">Автонастройки</h3>
    <div :class="$style.templateSelect">
      <elsa-v-select
        html-label="Тип документа"
        v-model="selectedTemplate"
        :options="templates"
        label="notify_name"
        :clearable="false"
      />
    </div>

    <div :class="$style.listHeader">
      <h4>Список статей</h4>
      <vs-button @click="onCreateArticle">
        Добавить
      </vs-button>
    </div>

    <div v-if="!articles">
      <div class="block-loading" />
    </div>
    <div v-else-if="!articles.length" :class="$style.articlesEmpty">Статей нет</div>
    <div v-else :key="article.id" v-for="(article, i) in articles" :class="$style.article">
      <div :class="$style.articleHead">
        <div :class="$style.articleTitle">
          {{ i + 1 }}. {{ article.article_name }}
        </div>
        <vs-checkbox :value="article.auto_add" @change="onChangeAutoAdd(article)">
          Добавлять в шаблон автоматически
        </vs-checkbox>
        <vs-button
          class="ml-2"
          size="small"
          type="border"
          iconPack="feather"
          icon="icon-edit"
          title="Изменить"
          @click="onEditArticle(article)"
        />
        <vs-button
          class="ml-2"
          size="small"
          type="border"
          iconPack="feather"
          icon="icon-trash"
          title="Удалить"
          @click="onDeleteArticle(article)"
        />
      </div>
      <div :key="tariff.id" v-for="tariff in article.tariffs" :class="$style.tariff">
        {{ tariff.name }} <span v-if="tariff.is_archive">(в архиве)</span>
      </div>
    </div>

    <h4 v-if="preview || previewError" class="mb-4">Предпросмотр документа</h4>
    <div v-if="previewError" :class="$style.previewError">{{ previewError }}</div>
    <div v-if="preview" :class="$style.previewContainer">
      <img :class="$style.preview" :src="preview" alt="" />
    </div>
  </vx-card>
</template>

<script>
import notifyHttpError   from "@/mixins/notifyHttpError";
import mergeCommonErrors from "@/helpers/mergeCommonErrors";

export default {
  name:   "NotifiesConfig",
  mixins: [notifyHttpError],
  data() {
    return {
      selectedTemplate: null,
      templates:        [],
      articles:         null,
      preview:          null,
      previewError:     null,
    };
  },
  computed: {
    selectedHouseId() {
      return this.$store.getters['appUser/selectedHouse'].id;
    },
  },
  methods:  {
    loadTemplates() {
      this.$http.get('notify/templates', { params: { buildings_id: this.selectedHouseId } }).then(( { data } ) => {
        this.templates = data;
        this.selectedTemplate = data[0];
      });
    },

    loadArticles() {
      if (!this.selectedTemplate) return;
      this.$http.get('notify/articles', {
        params: {
          type_id:      this.selectedTemplate.id,
          buildings_id: this.selectedHouseId,
        },
      }).then(( { data: { articles } } ) => {
        this.articles = articles;
        this.loadPreview();
      });
    },

    loadPreview() {
      this.$http.post(`notify/article/preview`, {
        buildings_id: this.selectedHouseId,
        is_preview:   true,
        articles:     this.articles.map(article => ({
          id:  article.id,
          sum: '____.__',
        })),
      }, { responseType: 'arraybuffer' }).then(
        ( { data } ) => {
          this.previewError = null;
          this.preview = window.URL.createObjectURL(new Blob([data]));
        },
        ( e ) => {
          const decoder = new TextDecoder("utf-8");
          const errors = JSON.parse(decoder.decode(e.response.data));
          this.previewError = mergeCommonErrors(errors.errors, []).common;
          this.preview = null;
        },
      );
    },

    onCreateArticle() {
      this.$modal.open({
        // size:           '',
        overflowHeight: true,
        title:          'Создать статью',
        component:      () => import('@/components/notifies/NotifiesCreateArticlePopup'),
        componentProps: {
          onSubmit: ( { article_name, tariffs } ) => {
            return this.$http.post('notify/article', {
              article_name,
              type_id:      this.selectedTemplate.id,
              buildings_id: this.selectedHouseId,
              tariffs,
            }).then(this.loadArticles);
          },
        },
      });
    },

    onEditArticle( article ) {
      this.$modal.open({
        // size:           '',
        overflowHeight: true,
        title:          'Изменить статью',
        component:      () => import('@/components/notifies/NotifiesCreateArticlePopup'),
        componentProps: {
          article,
          onSubmit: ( { article_name, tariffs } ) => {
            return this.$http.put(`notify/articles/${article.id}`, {
              type_id:      article.type_id,
              buildings_id: article.building_id,
              article_name,
              tariffs,
            }).then(this.loadArticles);
          },
        },
      });
    },

    onDeleteArticle( article ) {
      this.$modal.openConfirm({
        message:    `Вы уверены, что хотите удалить статью ${article.article_name}?`,
        buttonText: 'Удалить',
      }).result.then(() => {
        return this.$http.delete(`notify/articles/${article.id}`, {
          params: {
            buildings_id: this.selectedHouseId,
            //   article_id:   article.id,
          },
        }).then(
          this.loadArticles,
          this.notifyHttpError,
        );
      });
    },

    onChangeAutoAdd( article ) {
      return this.$http.put(`notify/articles/${article.id}`, {
        buildings_id: this.selectedHouseId,
        // article_id: article.id,
        auto_add: !article.auto_add,
      }).then(this.loadArticles);
    },
  },
  mounted() {
    this.loadTemplates();
    this.loadArticles();
  },
  watch: {
    selectedHouseId() {
      this.articles = null;
      this.loadArticles();
    },
    selectedTemplate() {
      this.articles = null;
      this.loadArticles();
    },
  },
};
</script>

<style lang="scss" module>
.templateSelect {
  width: 450px;
  margin-bottom: 2em;
}

.articlesEmpty {
  font-size: 24px;
  text-align: center;
  margin: 1em 0;
  font-style: italic;
  opacity: .5;
}

.listHeader {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1em;
}

.article {
  margin-bottom: 20px;
}

.articleHead {
  background: #F3F3F3;
  height: 40px;
  display: flex;
  align-items: center;
  padding: 0 15px;
}

.articleTitle {
  font-weight: 500;
  font-size: 18px;
  margin-right: auto;
}

.tariff {
  border: 1px solid #F3F3F3;
  border-top: 0;
  //border-bottom: 0;
  padding: 5px 13px;

  span {
    opacity: .5;
  }
}

.previewContainer {
  display: flex;
  justify-content: center;
  background: #D2D6D9;
  padding: 1em;
}

.preview {
  width: auto;
  display: inline-block;
  max-width: 100%;
}

.previewError {
  color: color(danger);
}
</style>
